import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {EventTypeBO} from "./EventTypeBO";

export class EventTypeBOAudit {

    // Audit Log Service for Event Type

    static async EventTypeAuditBO(EventTypeBO: EventTypeBO): Promise<AuditService> {
        const self = EventTypeBO

        const auditService = new AuditService(new PAdbContext({}))
        auditService.setReference("EventType", self.drWB_EventType.cif.WB_EVTTYPE_ID)
        let sType:string = "Unknown"
        sType = self.drWB_EventType.cif.TYPE_ID

        if (self.WB_EventType.isActiveNew)
            await auditService.Log(AuditLogType.CreateNew, 'Event Type Added, ' + sType)

        // Spend Types

        for (let aEvtSpndTypeRelRow of self.drWB_EventType.WB_EventSpendTypeRows) {
            // let sUsrName = 'Unknown'd
            if (aEvtSpndTypeRelRow.WB_EventType) {
                sType = aEvtSpndTypeRelRow.WB_EventType.cif.TYPE_ID
            }
            if (aEvtSpndTypeRelRow.isActiveNew) {
                await auditService.Log(AuditLogType.CreateNew, 'Event Type Spend Type Added, ' + sType)
            }

            if (aEvtSpndTypeRelRow.WB_EventType)
                if (!aEvtSpndTypeRelRow.isActive && !aEvtSpndTypeRelRow.isNew() && !(aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID in self.dctAuditedDeletes)) {
                    await auditService.Log(AuditLogType.Delete, 'Event Type Spend Type Deleted, ' + sType)
                    self.dctAuditedDeletes[aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID] = aEvtSpndTypeRelRow.cif.WB_EVTSTYPR_ID
                }

            // Logging date changes in product
            let changedDates: string[] = ['EFFECTIVE_START_DT', 'EFFECTIVE_END_DT']
            let changedArr = aEvtSpndTypeRelRow.getChangedProperties({ properties: changedDates })
            if (changedArr.length) {
                for (let fieldName of changedArr) {
                    let curValue = (<any>aEvtSpndTypeRelRow)[fieldName]
                    let prevValue = aEvtSpndTypeRelRow.previous(fieldName)
                    await auditService.Log(AuditLogType.Change, `${fieldName} changed, key value changed from ${prevValue} to ${curValue}`)
                }
            }

        }

        // Rate Settings , Workflow, UI Settings, Data Settings, Other Settings

        let propsToCheck: string[] = ['SUBPLANNING_CUST_SHOW_IND', 'COVERAGEFACTOR_LEVEL', 'PLANNING_CUST_SHOW_IND', 'MERCH_ACV_LEVEL',
            'COVERAGEFACTOR_SHOW_IND', 'INSTOREDATES_SHOW_IND', 'INSTOREDATES_POLICY', 'SHIPMENTDATES_SHOW_IND', 'SHIPMENTDATES_POLICY', 'ORDERDATES_SHOW_IND',
            'ORDERDATES_POLICY', 'DISTRIBUTIONDATES_SHOW_IND', 'DISTRIBUTIONDATES_POLICY', 'PAIDINFULL_SHOW_IND', 'WB_WORKFLOW_ID', 'DISPLAYS_SHOW_IND', 'PRODUCTGROUPS_SHOW_IND', 'PLANNED_SPEND_SHOW_IND',
            'APPROVED_SPEND_SHOW_IND', 'ACTUAL_SPEND_SHOW_IND', 'LE_SPEND_SHOW_IND', 'COPY_POLICY', 'WORKFLOW_POLICY', 'TAGS_SHOW_IND', 'WB_TAGS_ID_USAGES', 'COMMENTS_SHOW_IND',
            'CREATOR_SHOW_IND', 'PLAN_SHOW_IND', 'PLAN_POLICY', 'CALC_VOLUMELAYER_ID', 'PGGROSSLISTPRICE_SHOW_IND', 'PGNETLISTPRICE_SHOW_IND',
            'PGBASEPRICE_SHOW_IND', 'PGBASEPRICE_POLICY', 'PGBASEPRICE_REQUIRED_IND',
            'PGEDLPPRICE_SHOW_IND', 'PGEDLPPRICE_POLICY', 'PGEDLPPRICE_REQUIRED_IND',
            'PGPROMOTEDPRICE_SHOW_IND', 'PGPROMOTEDPRICE_POLICY', 'PGPROMOTEDPRICE_REQUIRED_IND',
            'PGDISCOUNTPCNT_SHOW_IND', 'PGDISCOUNTPCNT_POLICY', 'PGDISCOUNTPCNT_REQUIRED_IND',
            'PGDISCOUNTAMT_SHOW_IND', 'PGDISCOUNTAMT_POLICY', 'PGDISCOUNTAMT_REQUIRED_IND',
            'PGCNSBASE_SHOW_IND', 'PGCNSBASEEDLP_SHOW_IND', 'PGCNSEDLP_SHOW_IND', 'PGCNSEDLP_POLICY',
            'PGCNSINCR_SHOW_IND', 'PGCNSINCR_POLICY', 'PGCNSCANN_SHOW_IND', 'PGCNSCANN_POLICY', 'PGCNSTOTAL_SHOW_IND', 'PGCNSTOTAL_POLICY', 'PGSHPBASE_SHOW_IND', 'PGSHPBASEEDLP_SHOW_IND',
            'PGSHPEDLP_SHOW_IND', 'PGSHPEDLP_POLICY', 'PGSHPINCR_SHOW_IND', 'PGSHPINCR_POLICY', 'PGSHPFWDBUYPCNT_SHOW_IND', 'PGSHPFWDBUYPCNT_POLICY',
            'PGSHPFWDBUY_SHOW_IND', 'PGSHPADJ_SHOW_IND', 'PGSHPADJ_POLICY', 'PGSHPTOTAL_SHOW_IND', 'PGSHPTOTAL_POLICY', 'PGSHPDISP_SHOW_IND', 'PGSHPDISP_POLICY', 'PGCNSLIFTPCNT_SHOW_IND',
            'PGCNSLIFTPCNT_POLICY', 'PGCNSLIFTPCNTOVR_SHOW_IND', 'PGCNSLIFTPCNTOVR_POLICY', 'PGSHPFWDBUY_POLICY', 'PGCNSVOL_POLICY', 'PGSHPVOL_POLICY', 'PROD_SHOW_IND', 'CONSUMER_PRODUCT_POLICY',
            'FINISHED_PRODUCT_POLICY', 'PRODUCT_PERIOD_PRDTYPES', 'PROD_PERIOD_SHOW_IND', 'EVENT_LAYER']
        let changedArr = self.drWB_EventType.getChangedProperties({ properties: propsToCheck })
        if (changedArr.length) {
            for (let fieldName of changedArr) {
                let curValue = (<any>self.drWB_EventType)[fieldName]
                let prevValue = self.drWB_EventType.previous(fieldName)
                await auditService.Log(AuditLogType.Change, `${fieldName} changed, key value changed from ${prevValue} to ${curValue}`)
            }
        }

        await auditService.Save()

        return auditService
    }

}
